import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {Button, Dropdown, Modal, Radio} from "antd";
import {getImagePathWithTheme} from "../../../utils";
import {t} from "i18next";

const DialogMindmapLinkMode = forwardRef((props:{onCloseEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [mode, setMode] = useState<string>("insertion");
    const mCallback = useRef<any>(null);

    const onShowDialog = (callback:any)=>{
        setIsShowDialog(true);
        mCallback.current = callback;
    }

    return(
        <Modal width={480} bodyStyle={{height: '500px', fontSize: '12px'}} open={isShowDialog} footer={null} centered={true} onCancel={(e)=> {
            setIsShowDialog(false);
            props.onCloseEvent();
        }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    {/*<img className={'img-26 mr-4'} style={{marginTop: '-2.5px'}}*/}
                    {/*     src={getImagePathWithTheme('dialog_highlight')}/>*/}
                    <span className={'dialog-title span-single-line mr-16'}>{t("SelectedImageMode")}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>

                <Radio.Group onChange={(event)=>{
                    setMode(event.target.value);
                }} value={mode} style={{display:'flex',flexDirection:'column',flexGrow:'1'}}>
                    <Radio value={"insertion"}>{t("EmbedMode")}</Radio>
                    <Radio value={"icon"}>{t("IconMode")}</Radio>
                </Radio.Group>

                <div className={'flex-row-vertical-center'}>
                    {
                        <Button
                            style={{height: '34px'}}
                            className='large-w-button button-border-gray-style button-min-width font-size-14 font-family-medium'
                            onClick={() => {
                                setIsShowDialog(false);
                            }}>{t("Cancel")}</Button>
                    }
                    <Button
                        className='large-w-button button-solid-style button-min-width font-size-14 font-family-medium'
                        type="primary"
                        onClick={() => {
                            if (mCallback.current) {
                                mCallback.current(mode);
                            }
                            props.onCloseEvent();
                        }}
                        style={{marginLeft: '26px',background:"var(--button-background-color)"}}
                        htmlType={"submit"}>{t("Confirm")}</Button>
                </div>

            </div>
        </Modal>
)
})

export default DialogMindmapLinkMode;



























